/* ============================================================
   FEED1 — KOMUNITI SESAAT (MOCKUP UI/UX SAHAJA)
   ============================================================
   Route: /feed1 (admin-only, lihat App.jsx)

   Konsep besar: forum/social feed untuk ejen affiliate TikTok &
   Shopee berkumpul. Setiap ahli ada PROFIL AWAM (link boleh kongsi
   di bio TikTok) + KEDAI (collection monetize: panduan/ebook, kelas,
   masterclass, membership, custom GPT, formula, link aff).

   Enjin viral yang dilakarkan dalam mockup ini:
     1. Profil awam = landing page percuma (sesaat.ai/@handle)
     2. Kad Kongsi berjenama auto (resit komisen → poster + QR + ref)
     3. Ganjaran jemputan bertingkat (1/3/10/25 rakan)
     4. Cabaran mingguan + hashtag (kandungan TikTok = iklan percuma)
     5. Carta Juara awam (status & gamifikasi)
     6. Kandungan berkunci — buka dengan follow / daftar percuma
     7. Mod Tetamu — tunjuk apa orang LUAR nampak + CTA daftar

   ⛔ TIADA backend, TIADA Firestore, TIADA logic sebenar.
      Semua nama, angka, produk & resit = DATA PALSU untuk demo.
      State tempatan hanya untuk navigasi/tab/toggle/toast.

   Gaya: SESAAT Studio v3.9 (tokens.css + ui.css) — gelap, monokrom,
   tiada emoji, warna jenama untuk identiti sahaja, --s-ok untuk duit.
   Halaman ini overlay penuh skrin (macam StudioShell) dengan rel
   menu komuniti sendiri — sengaja TIDAK menyentuh StudioShell supaya
   prototaip v3.9 sedia ada kekal betul-betul seperti sebelum ini.
   ============================================================ */

import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    ArrowLeftFromLine, Newspaper, Trophy, Target, GraduationCap, Store,
    CircleUser, Gift, Search, Heart, MessageCircle, Share2, Bookmark,
    BadgeCheck, MoreHorizontal, TrendingUp, Lock, Play, Link2, Copy, X,
    Users, Crown, Flame, CalendarDays, Clock, Star, ChevronRight, QrCode,
    Download, FileText, Bot, Layers, Check, Eye, Plus, Zap, ArrowUpRight,
} from 'lucide-react';

import '../design/tokens.css';
import { Badge, Btn, Card, Segmented, Field, NavRow, ContentPanel } from '../design/ui';

/* ════════════════════════════════════════════════════════════
   DATA DUMMY
   ════════════════════════════════════════════════════════════ */

// "Saya" dalam mockup — persona contoh, bukan akaun sebenar.
const SAYA = {
    nama: 'Aina Zahra', handle: '@ainazahra', tick: true,
    level: 'Juara RM10K', pengikut: 1284, jualan: 312, pelajar: 96,
    bio: 'Ejen affiliate TikTok Shop sejak 2024. Saya kongsi formula video yang saya guna setiap hari — semua video dijana dengan SESAAT.',
    link: 'sesaat.ai/@ainazahra',
    ref: 'https://sesaat.ai/?ref=AFR-7K2P9',
};

const AHLI = {
    aiman: { nama: 'Aiman Hakimi', handle: '@aimanhakimi', level: 'Top Closer', tick: true },
    nurul: { nama: 'Nurul Aina', handle: '@nurulaina.tt', level: 'Konsisten 21 Hari', tick: false },
    faez: { nama: 'Faez Megat', handle: '@faezmegat', level: 'Mentor', tick: true },
    puteri: { nama: 'Puteri Sofea', handle: '@puterisofea', level: 'Rising Star', tick: false },
    amir: { nama: 'Amir Danial', handle: '@amirdanial', level: 'Ahli Baharu', tick: false },
    syafiq: { nama: 'Syafiq Zul', handle: '@syafiqzul', level: 'Perintis', tick: false },
    admin: { nama: 'Team SESAAT', handle: '@sesaat', level: 'Admin', tick: true, admin: true },
};

const POSTS = [
    {
        id: 'pin1', jenis: 'cabaran', pin: true, oleh: AHLI.admin, masa: 'Disematkan',
        teks: 'Cabaran minggu ini: tutup 5 jualan sebelum Ahad dan post resit anda di sini dengan tag #SesaatChallenge. Pemenang utama bawa pulang RM500 + badge Juara Mingguan.',
        peserta: 234, suka: 128, komen: 34,
    },
    {
        id: 'w1', jenis: 'resit', oleh: AHLI.aiman, masa: '12 min', auto: true,
        teks: 'Alhamdulillah, masuk lagi satu dari video semalam yang naik FYP. Konsisten memang kunci — video ni set ke-3 dari generation pagi tadi.',
        resit: { jumlah: 'RM248.60', sumber: 'TikTok Shop · 2 jualan', produk: 'Serum GlowUp Vitamin C' },
        suka: 47, komen: 12, kunciTetamu: false,
    },
    {
        id: 'f1', jenis: 'formula', oleh: AHLI.nurul, masa: '48 min',
        teks: 'Saya kongsikan formula GOYANG yang saya guna sepanjang bulan ni — 3 set prompt siap tune untuk produk kesihatan. Follow untuk buka.',
        formula: { nama: 'Formula GOYANG Musim Raya', isi: '3 set prompt · 1 template avatar', muatTurun: '1.2K' },
        suka: 96, komen: 28, kunciTetamu: true,
    },
    {
        id: 'q1', jenis: 'soalan', oleh: AHLI.amir, masa: '2 jam',
        teks: 'Soalan newbie — macam mana nak tulis caption TikTok yang tak kena reach limit? Video saya asyik kena hadkan tontonan.',
        jawapan: { oleh: AHLI.faez, teks: 'Elak perkataan sensitif macam "murah gila" dan link luar dalam caption. Guna caption yang dijana SESAAT — ia memang ditapis untuk perkataan berisiko.', membantu: 41 },
        suka: 15, komen: 41, kunciTetamu: true,
    },
    {
        id: 'v1', jenis: 'video', oleh: AHLI.puteri, masa: '3 jam',
        teks: 'Video ni sampai 128K tontonan dalam 18 jam. Hook 3 saat pertama tu saya ambil dari kelas Masterclass minggu lepas — berbaloi sangat.',
        video: { tontonan: '128K tontonan', tempoh: '0:21' },
        suka: 84, komen: 19, kunciTetamu: false,
    },
    {
        id: 'k1', jenis: 'kelas', oleh: AHLI.faez, masa: '5 jam',
        teks: 'Rabu ini saya buat sesi live percuma untuk semua ahli — saya bedah 3 video FYP dan tunjuk kenapa ia menjual. Tempat terhad.',
        kelas: { tajuk: 'Live: Bedah Video FYP', masa: 'Rabu · 9:00 malam', rsvp: 96, harga: 'Percuma' },
        suka: 52, komen: 9, kunciTetamu: false,
    },
    {
        id: 'p1', jenis: 'produk', oleh: SAYA, masa: '6 jam', sendiri: true,
        teks: 'Ebook saya dah dikemas kini untuk 2026 — tambah bab baharu pasal pemilihan produk winning. Pembeli lama dapat update percuma.',
        produk: { jenis: 'ebook', nama: 'Panduan 0 ke RM10K Komisen TikTok', harga: 'RM39', terjual: 412, rating: '4.9' },
        suka: 63, komen: 21, kunciTetamu: true,
    },
    {
        id: 't1', jenis: 'tip', oleh: AHLI.nurul, masa: '8 jam',
        teks: 'Tip untuk yang baru mula: jangan post satu video sehari. Saya jana 3 set sekali gus dengan SESAAT dan post pagi, petang, malam. Capaian 3 kali ganda, jualan pun naik.',
        suka: 63, komen: 21, kunciTetamu: false,
    },
];

const TAPIS_FEED = [
    { value: 'semua', label: 'Semua' },
    { value: 'resit', label: 'Resit Jualan' },
    { value: 'tip', label: 'Tip' },
    { value: 'soalan', label: 'Soalan' },
    { value: 'video', label: 'Video' },
];

const PRODUK = [
    { id: 1, jenis: 'ebook', nama: 'Panduan 0 ke RM10K Komisen TikTok', oleh: SAYA, harga: 'RM39', terjual: 412, rating: '4.9' },
    { id: 2, jenis: 'kelas', nama: 'Masterclass Hook 3 Saat', oleh: AHLI.aiman, harga: 'RM99', terjual: 96, rating: '5.0' },
    { id: 3, jenis: 'membership', nama: 'Inner Circle Aina — Komuniti VIP', oleh: SAYA, harga: 'RM29/bln', terjual: 154, rating: '4.8' },
    { id: 4, jenis: 'gpt', nama: 'Skrip Video Pro GPT (Custom GPT)', oleh: AHLI.faez, harga: 'RM49', terjual: 208, rating: '4.7' },
    { id: 5, jenis: 'formula', nama: 'Formula GOYANG Musim Raya', oleh: AHLI.nurul, harga: 'Percuma', terjual: 1200, rating: '4.9', kunciFollow: true },
    { id: 6, jenis: 'ebook', nama: '50 Produk Winning Shopee 2026', oleh: AHLI.puteri, harga: 'RM25', terjual: 178, rating: '4.6' },
    { id: 7, jenis: 'kelas', nama: 'Live Selling Bootcamp (2 Hari)', oleh: AHLI.faez, harga: 'RM199', terjual: 64, rating: '4.9' },
    { id: 8, jenis: 'aff', nama: 'Pek Link Aff Komisen Tinggi — Ogos', oleh: AHLI.syafiq, harga: 'Percuma', terjual: 890, rating: '4.5' },
];

const JENIS_PRODUK = {
    ebook: { label: 'Ebook', ikon: FileText },
    kelas: { label: 'Kelas', ikon: GraduationCap },
    membership: { label: 'Membership', ikon: Users },
    gpt: { label: 'Custom GPT', ikon: Bot },
    formula: { label: 'Formula', ikon: Layers },
    aff: { label: 'Link Aff', ikon: Link2 },
};

const TAPIS_PRODUK = [
    { value: 'semua', label: 'Semua' },
    { value: 'ebook', label: 'Ebook' },
    { value: 'kelas', label: 'Kelas' },
    { value: 'membership', label: 'Membership' },
    { value: 'gpt', label: 'Custom GPT' },
    { value: 'formula', label: 'Formula' },
];

const CARTA = {
    komisen: [
        { ahli: AHLI.faez, nilai: 'RM2,786', info: '14 jualan' },
        { ahli: AHLI.aiman, nilai: 'RM2,189', info: '11 jualan' },
        { ahli: AHLI.nurul, nilai: 'RM1,791', info: '9 jualan' },
        { ahli: SAYA, nilai: 'RM1,393', info: '7 jualan', saya: true },
        { ahli: AHLI.puteri, nilai: 'RM1,194', info: '6 jualan' },
    ],
    jemputan: [
        { ahli: SAYA, nilai: '23 ahli', info: '9 aktif minggu ini', saya: true },
        { ahli: AHLI.nurul, nilai: '18 ahli', info: '7 aktif minggu ini' },
        { ahli: AHLI.syafiq, nilai: '14 ahli', info: '6 aktif minggu ini' },
        { ahli: AHLI.puteri, nilai: '11 ahli', info: '4 aktif minggu ini' },
        { ahli: AHLI.amir, nilai: '8 ahli', info: '3 aktif minggu ini' },
    ],
    kreator: [
        { ahli: AHLI.nurul, nilai: '4,120 reaksi', info: '12 post minggu ini' },
        { ahli: AHLI.faez, nilai: '3,480 reaksi', info: '8 post minggu ini' },
        { ahli: SAYA, nilai: '2,940 reaksi', info: '9 post minggu ini', saya: true },
        { ahli: AHLI.aiman, nilai: '2,210 reaksi', info: '6 post minggu ini' },
        { ahli: AHLI.amir, nilai: '1,105 reaksi', info: '5 post minggu ini' },
    ],
};

const CABARAN = [
    {
        id: 'c1', status: 'aktif', tajuk: 'Cabaran 30 Hari Posting',
        keterangan: 'Post sekurang-kurangnya 1 video TikTok setiap hari selama 30 hari. Tag #SesaatChallenge supaya kami boleh jejak — dan supaya dunia nampak.',
        hari: 12, jumlahHari: 30, peserta: 234, hadiah: 'RM500 + badge Juara Mingguan',
        syarat: ['Post 1 video sehari di TikTok', 'Letak tag #SesaatChallenge pada caption', 'Kongsi resit jualan di Feed setiap kali close'],
    },
    {
        id: 'c2', status: 'akan', tajuk: 'Sprint Resit — 7 Hari',
        keterangan: 'Sesiapa kumpul jumlah komisen tertinggi dalam 7 hari menang. Semua resit disahkan melalui post Feed.',
        mula: 'Mula 15 Ogos', peserta: 0, hadiah: 'RM300 + slot mentoring Faez Megat',
    },
    {
        id: 'c3', status: 'tamat', tajuk: 'Cabaran Video Pertama',
        keterangan: 'Untuk ahli baharu — jana dan post video pertama anda dalam masa 48 jam selepas daftar.',
        peserta: 412, pemenang: AHLI.syafiq, hadiah: 'RM300',
    },
];

const KELAS = [
    { id: 'e1', tajuk: 'Live: Bedah Video FYP', host: AHLI.faez, masa: 'Rabu, 20 Ogos', jam: '9:00 malam', harga: 'Percuma', rsvp: 96, tarikh: '20', bulan: 'OGO' },
    { id: 'e2', tajuk: 'Masterclass Hook 3 Saat', host: AHLI.aiman, masa: 'Sabtu, 23 Ogos', jam: '10:00 pagi', harga: 'RM99', rsvp: 41, tarikh: '23', bulan: 'OGO' },
    { id: 'e3', tajuk: 'Sesi Onboarding Ahli Baharu', host: AHLI.admin, masa: 'Isnin, 25 Ogos', jam: '8:30 malam', harga: 'Percuma', rsvp: 128, tarikh: '25', bulan: 'OGO' },
];

const RAKAMAN = [
    { id: 'r1', tajuk: 'Asas TikTok Shop Affiliate', tempoh: '42 min', kunci: false },
    { id: 'r2', tajuk: 'Cara Pilih Produk Winning', tempoh: '38 min', kunci: true },
    { id: 'r3', tajuk: 'Strategi Posting 3x Sehari', tempoh: '27 min', kunci: true },
];

const GANJARAN = [
    { sasaran: 1, label: 'Badge Pembuka Jalan', capai: true },
    { sasaran: 3, label: 'Kelas rakaman percuma', capai: true },
    { sasaran: 10, label: 'Kredit RM50', capai: false },
    { sasaran: 25, label: 'Status VIP + komisen bonus', capai: false },
];

const TESTIMONI = [
    { oleh: AHLI.puteri, teks: 'Beli ebook Aina bulan lepas — minggu pertama terus dapat resit pertama saya. Penerangan dia senang faham untuk orang baru.' },
    { oleh: AHLI.amir, teks: 'Inner Circle berbaloi. Setiap minggu ada review video langsung, dan formula yang dikongsi memang yang dia guna sendiri.' },
];

/* ════════════════════════════════════════════════════════════
   BLOK BINAAN KECIL
   ════════════════════════════════════════════════════════════ */

const inisial = (nama = '?') => nama.trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join('').toUpperCase();

const Avatar = ({ ahli, saiz = 34 }) => (
    <span style={{
        width: saiz, height: saiz, borderRadius: 99, flex: 'none',
        display: 'grid', placeItems: 'center',
        background: 'var(--s-brand-soft)', color: 'var(--s-brand)',
        fontSize: Math.max(10, Math.round(saiz * 0.34)), fontWeight: 600,
    }}>{inisial(ahli?.nama)}</span>
);

const NamaAhli = ({ ahli, masa, auto }) => (
    <span style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0, fontSize: 13.5 }}>
        <span style={{ fontWeight: 600, color: 'var(--s-ink)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {ahli.nama}
        </span>
        {ahli.tick && <BadgeCheck size={14} style={{ color: 'var(--s-brand)', flex: 'none' }} />}
        <span className="s-dim" style={{ whiteSpace: 'nowrap' }}>{ahli.handle}</span>
        {masa && <span className="s-dim" style={{ whiteSpace: 'nowrap' }}>· {masa}</span>}
        {auto && (
            <span className="s-dim" style={{ display: 'inline-flex', alignItems: 'center', gap: 3, whiteSpace: 'nowrap' }}>
                · <Zap size={11} /> auto
            </span>
        )}
    </span>
);

/* Butang aksi bawah post — Suka/Komen/Kongsi/Simpan. */
const AksiPost = ({ Ikon, kiraan, aktif, onClick, warnaAktif = 'var(--s-ink)' }) => (
    <button
        type="button"
        onClick={onClick}
        style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            background: 'none', border: 0, cursor: 'pointer', padding: '4px 6px',
            borderRadius: 7, fontFamily: 'inherit', fontSize: 12.5,
            color: aktif ? warnaAktif : 'var(--s-ink-3)',
            fontVariantNumeric: 'tabular-nums',
        }}
    >
        <Ikon size={16} strokeWidth={1.9} fill={aktif ? 'currentColor' : 'none'} />
        {kiraan != null && <span>{kiraan}</span>}
    </button>
);

/* Label kumpulan rel — gaya "SPACE" StudioRail. */
const LabelKumpulan = ({ children }) => (
    <span style={{
        fontSize: 10, fontWeight: 700, letterSpacing: '.08em',
        color: 'var(--s-ink-3)', padding: '0 8px', marginBottom: 4, display: 'block',
    }}>{children}</span>
);

/* Kotak link + butang salin — dipakai di merata (profil, jemputan, share). */
const KotakLink = ({ link, onSalin }) => (
    <div style={{
        display: 'flex', alignItems: 'center', gap: 8, minWidth: 0,
        border: '1px solid var(--s-line-strong)', borderRadius: 8,
        background: 'var(--s-ground)', padding: '0 10px', height: 38,
    }}>
        <Link2 size={14} style={{ color: 'var(--s-ink-3)', flex: 'none' }} />
        <span style={{
            flex: 1, minWidth: 0, fontSize: 13, color: 'var(--s-ink-2)',
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
        }}>{link}</span>
        <button
            type="button" onClick={onSalin}
            style={{
                display: 'inline-flex', alignItems: 'center', gap: 5, flex: 'none',
                background: 'none', border: 0, cursor: 'pointer', padding: 0,
                fontFamily: 'inherit', fontSize: 12.5, fontWeight: 600, color: 'var(--s-ink)',
            }}
        >
            <Copy size={13} /> Salin
        </button>
    </div>
);

/* Kad produk marketplace/koleksi. */
const KadProduk = ({ p, onBuka, onToast }) => {
    const meta = JENIS_PRODUK[p.jenis] || JENIS_PRODUK.ebook;
    const IkonJenis = meta.ikon;
    const percuma = p.harga === 'Percuma';
    return (
        <Card hover className="s-pcard">
            <button
                type="button" onClick={onBuka}
                style={{ all: 'unset', cursor: 'pointer', display: 'block' }}
            >
                <div className="s-thumb s-thumb--besar">
                    <IkonJenis size={30} strokeWidth={1.6} />
                    <span style={{ position: 'absolute', top: 10, left: 10 }}>
                        <Badge tone="neutral">{meta.label}</Badge>
                    </span>
                    {p.kunciFollow && (
                        <span style={{ position: 'absolute', top: 10, right: 10 }}>
                            <Badge tone="brand"><Lock size={11} /> Follow</Badge>
                        </span>
                    )}
                </div>
                <div style={{ padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <p className="s-cardname s-clamp2" style={{ lineHeight: 1.4, minHeight: 39 }}>{p.nama}</p>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 7, minWidth: 0 }}>
                        <Avatar ahli={p.oleh} saiz={20} />
                        <span className="s-dim" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {p.oleh.nama}
                        </span>
                        {p.oleh.tick && <BadgeCheck size={12} style={{ color: 'var(--s-brand)', flex: 'none' }} />}
                    </span>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 12, color: 'var(--s-ink-3)', fontVariantNumeric: 'tabular-nums' }}>
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
                            <Star size={11} fill="currentColor" /> {p.rating}
                        </span>
                        <span>{p.terjual.toLocaleString()} {p.jenis === 'kelas' ? 'pelajar' : p.jenis === 'membership' ? 'ahli' : 'diambil'}</span>
                    </span>
                </div>
            </button>
            <div className="s-cardfoot" style={{ marginTop: 'auto' }}>
                <span style={{ fontSize: 14.5, fontWeight: 600, color: percuma ? 'var(--s-ok)' : 'var(--s-ink)', fontVariantNumeric: 'tabular-nums' }}>
                    {p.harga}
                </span>
                <span style={{ flex: 1 }} />
                <Btn size="sm" variant={percuma ? 'ghost' : 'primary'} onClick={() => onToast(percuma ? 'Demo — dapatkan percuma' : 'Demo — halaman beli belum dibina')}>
                    {percuma ? 'Dapatkan' : 'Beli'}
                </Btn>
            </div>
        </Card>
    );
};

/* Baris carta juara. */
const BarisCarta = ({ kedudukan, item }) => (
    <div className="s-list__row" style={item.saya ? { background: 'var(--s-fill)', boxShadow: 'inset 2px 0 0 var(--s-select)' } : undefined}>
        <span style={{
            width: 22, textAlign: 'center', flex: 'none', fontVariantNumeric: 'tabular-nums',
            fontSize: 12.5, fontWeight: 700,
            color: kedudukan === 1 ? 'var(--s-warn)' : 'var(--s-ink-3)',
        }}>
            {kedudukan === 1 ? <Crown size={15} style={{ marginTop: 2 }} /> : kedudukan}
        </span>
        <Avatar ahli={item.ahli} saiz={30} />
        <span style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--s-ink)', display: 'flex', alignItems: 'center', gap: 5 }}>
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.ahli.nama}</span>
                {item.saya && <Badge tone="brand">Anda</Badge>}
            </span>
            <span className="s-dim">{item.info}</span>
        </span>
        <span style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--s-ink)', fontVariantNumeric: 'tabular-nums', flex: 'none' }}>
            {item.nilai}
        </span>
    </div>
);

/* ════════════════════════════════════════════════════════════
   POST FEED
   ════════════════════════════════════════════════════════════ */

const KunciTetamu = ({ onDaftar }) => (
    <div style={{
        border: '1px dashed var(--s-line-strong)', borderRadius: 10,
        padding: '18px 16px', display: 'flex', alignItems: 'center', gap: 12, marginTop: 10,
    }}>
        <Lock size={16} style={{ color: 'var(--s-ink-3)', flex: 'none' }} />
        <span style={{ flex: 1, fontSize: 13, color: 'var(--s-ink-2)' }}>
            Kandungan penuh untuk ahli sahaja. Sertai komuniti — percuma.
        </span>
        <Btn size="sm" onClick={onDaftar}>Daftar Percuma</Btn>
    </div>
);

const PostFeed = ({ post, tetamu, onToast, onKongsi }) => {
    const [suka, setSuka] = useState(false);
    const [simpan, setSimpan] = useState(false);
    const dikunci = tetamu && post.kunciTetamu;

    return (
        <Card>
            <div style={{ padding: '15px 18px 13px' }}>
                {post.pin && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
                        <Badge tone="brand"><Flame size={11} /> Cabaran Minggu Ini</Badge>
                    </div>
                )}

                <div style={{ display: 'flex', gap: 11 }}>
                    <Avatar ahli={post.oleh} saiz={36} />
                    <div style={{ minWidth: 0, flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <NamaAhli ahli={post.oleh} masa={post.masa} auto={post.auto} />
                            <span style={{ flex: 1 }} />
                            <button type="button" onClick={() => onToast('Menu post — demo')} style={{ background: 'none', border: 0, cursor: 'pointer', color: 'var(--s-ink-3)', padding: 2 }}>
                                <MoreHorizontal size={16} />
                            </button>
                        </div>

                        <p style={{ margin: '7px 0 0', fontSize: 14, lineHeight: 1.6, color: 'var(--s-ink-2)', whiteSpace: 'pre-wrap' }}>
                            {post.teks}
                        </p>

                        {/* ── Blok ikut jenis post ─────────────────────── */}
                        {dikunci ? (
                            <KunciTetamu onDaftar={() => onToast('Demo — borang daftar percuma')} />
                        ) : (
                            <>
                                {post.resit && (
                                    <div style={{
                                        marginTop: 12, border: '1px solid var(--s-line)', borderRadius: 10,
                                        background: 'var(--s-ground)', padding: '13px 15px',
                                        display: 'flex', alignItems: 'center', gap: 13, flexWrap: 'wrap',
                                    }}>
                                        <span style={{
                                            width: 36, height: 36, borderRadius: 9, flex: 'none',
                                            display: 'grid', placeItems: 'center',
                                            background: 'var(--s-ok-soft)', color: 'var(--s-ok)',
                                        }}><TrendingUp size={17} /></span>
                                        <span style={{ flex: 1, minWidth: 140, display: 'flex', flexDirection: 'column', gap: 3 }}>
                                            <span style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                                <span style={{ fontSize: 17, fontWeight: 700, color: 'var(--s-ok)', fontVariantNumeric: 'tabular-nums' }}>
                                                    +{post.resit.jumlah}
                                                </span>
                                                {/* Lawan screenshot palsu: SESAAT sahkan dgn data
                                                    sebenar pipeline — parit kepercayaan platform. */}
                                                <Badge tone="ok"><BadgeCheck size={11} /> Disahkan SESAAT</Badge>
                                            </span>
                                            <span className="s-dim">{post.resit.sumber} · {post.resit.produk}</span>
                                        </span>
                                        <Btn size="sm" variant="ghost" icon={<QrCode size={13} />} onClick={() => onKongsi(post)}>
                                            Jana Kad Kongsi
                                        </Btn>
                                    </div>
                                )}

                                {post.formula && (
                                    <div style={{
                                        marginTop: 12, border: '1px dashed var(--s-line-strong)', borderRadius: 10,
                                        padding: '13px 15px', display: 'flex', alignItems: 'center', gap: 13, flexWrap: 'wrap',
                                    }}>
                                        <span style={{
                                            width: 36, height: 36, borderRadius: 9, flex: 'none',
                                            display: 'grid', placeItems: 'center',
                                            background: 'var(--s-brand-soft)', color: 'var(--s-brand)',
                                        }}><Layers size={17} /></span>
                                        <span style={{ flex: 1, minWidth: 150, display: 'flex', flexDirection: 'column' }}>
                                            <span style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--s-ink)' }}>{post.formula.nama}</span>
                                            <span className="s-dim">{post.formula.isi} · {post.formula.muatTurun} muat turun</span>
                                        </span>
                                        <Btn size="sm" variant="ghost" icon={<Lock size={13} />} onClick={() => onToast('Demo — follow untuk buka formula')}>
                                            Buka dengan Follow
                                        </Btn>
                                    </div>
                                )}

                                {post.jawapan && (
                                    <div style={{
                                        marginTop: 12, borderLeft: '2px solid var(--s-line-strong)',
                                        padding: '2px 0 2px 13px', display: 'flex', flexDirection: 'column', gap: 6,
                                    }}>
                                        <span style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                                            <Avatar ahli={post.jawapan.oleh} saiz={22} />
                                            <span style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--s-ink)' }}>{post.jawapan.oleh.nama}</span>
                                            <Badge tone="ok"><Check size={11} /> Jawapan Terbaik</Badge>
                                        </span>
                                        <p style={{ margin: 0, fontSize: 13, lineHeight: 1.55, color: 'var(--s-ink-2)' }}>{post.jawapan.teks}</p>
                                        <span className="s-dim">{post.jawapan.membantu} orang kata membantu</span>
                                    </div>
                                )}

                                {post.video && (
                                    <div style={{ marginTop: 12, display: 'flex', gap: 13, alignItems: 'flex-end' }}>
                                        <div style={{
                                            width: 132, aspectRatio: '9 / 16', borderRadius: 10, flex: 'none',
                                            border: '1px solid var(--s-line-strong)', background: 'var(--s-ground)',
                                            display: 'grid', placeItems: 'center', position: 'relative',
                                        }}>
                                            <span style={{
                                                width: 34, height: 34, borderRadius: 99, display: 'grid', placeItems: 'center',
                                                background: 'var(--s-fill-hover)', color: 'var(--s-ink)',
                                            }}><Play size={15} fill="currentColor" /></span>
                                            <span className="s-num" style={{ position: 'absolute', right: 7, bottom: 7 }}>{post.video.tempoh}</span>
                                        </div>
                                        <span className="s-dim" style={{ display: 'inline-flex', alignItems: 'center', gap: 5, paddingBottom: 4 }}>
                                            <Eye size={13} /> {post.video.tontonan} di TikTok
                                        </span>
                                    </div>
                                )}

                                {post.kelas && (
                                    <div style={{
                                        marginTop: 12, border: '1px solid var(--s-line)', borderRadius: 10,
                                        padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
                                    }}>
                                        <span style={{
                                            width: 36, height: 36, borderRadius: 9, flex: 'none',
                                            display: 'grid', placeItems: 'center',
                                            background: 'var(--s-fill)', color: 'var(--s-ink-2)',
                                        }}><CalendarDays size={17} /></span>
                                        <span style={{ flex: 1, minWidth: 150, display: 'flex', flexDirection: 'column' }}>
                                            <span style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--s-ink)' }}>{post.kelas.tajuk}</span>
                                            <span className="s-dim">{post.kelas.masa} · {post.kelas.rsvp} RSVP · {post.kelas.harga}</span>
                                        </span>
                                        <Btn size="sm" onClick={() => onToast('Demo — RSVP direkod')}>RSVP</Btn>
                                    </div>
                                )}

                                {post.produk && (
                                    <div style={{
                                        marginTop: 12, border: '1px solid var(--s-line)', borderRadius: 10,
                                        background: 'var(--s-ground)', padding: '12px 14px',
                                        display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
                                    }}>
                                        <span style={{
                                            width: 36, height: 36, borderRadius: 9, flex: 'none',
                                            display: 'grid', placeItems: 'center',
                                            background: 'var(--s-fill)', color: 'var(--s-ink-2)',
                                        }}><FileText size={17} /></span>
                                        <span style={{ flex: 1, minWidth: 150, display: 'flex', flexDirection: 'column' }}>
                                            <span style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--s-ink)' }}>{post.produk.nama}</span>
                                            <span className="s-dim">
                                                {post.produk.harga} · {post.produk.terjual} terjual · <Star size={10} style={{ display: 'inline', verticalAlign: '-1px' }} fill="currentColor" /> {post.produk.rating}
                                            </span>
                                        </span>
                                        <Btn size="sm" variant="ghost" icon={<ArrowUpRight size={13} />} onClick={() => onToast('Demo — buka di Marketplace')}>
                                            Lihat
                                        </Btn>
                                    </div>
                                )}

                                {post.peserta != null && post.jenis === 'cabaran' && (
                                    <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                        <Badge tone="neutral"><Users size={11} /> {post.peserta} peserta</Badge>
                                        <Badge tone="neutral">#SesaatChallenge</Badge>
                                        <span style={{ flex: 1 }} />
                                        <Btn size="sm" onClick={() => onToast('Demo — anda menyertai cabaran')}>Sertai Cabaran</Btn>
                                    </div>
                                )}
                            </>
                        )}

                        {/* ── Aksi ─────────────────────────────────────── */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginTop: 12 }}>
                            <AksiPost Ikon={Heart} kiraan={post.suka + (suka ? 1 : 0)} aktif={suka} warnaAktif="var(--s-stop)" onClick={() => setSuka(!suka)} />
                            <AksiPost Ikon={MessageCircle} kiraan={post.komen} onClick={() => onToast('Komen — demo')} />
                            <AksiPost Ikon={Share2} onClick={() => onKongsi(post)} />
                            <span style={{ flex: 1 }} />
                            <AksiPost Ikon={Bookmark} aktif={simpan} onClick={() => { setSimpan(!simpan); onToast(simpan ? 'Dibuang dari simpanan' : 'Disimpan'); }} />
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

/* ════════════════════════════════════════════════════════════
   MODAL KONGSI (share sheet + pratonton Kad Kongsi berjenama)
   ════════════════════════════════════════════════════════════ */

const ModalKongsi = ({ post, onTutup, onToast }) => {
    if (!post) return null;
    const adaResit = !!post.resit;
    return (
        <div className="s-root s-modal" onClick={onTutup}>
            <div className="s-modal__panel" style={{ maxWidth: 620 }} onClick={(e) => e.stopPropagation()}>
                <div className="s-modal__head">
                    <span style={{ fontSize: 15, fontWeight: 600 }}>Kongsi & tarik ahli baharu</span>
                    <span style={{ flex: 1 }} />
                    <button type="button" className="s-modal__x" onClick={onTutup}><X size={14} /></button>
                </div>

                <div style={{ padding: 18, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 16 }}>
                    <p className="s-dim" style={{ lineHeight: 1.55 }}>
                        Link rujukan anda diselitkan secara automatik — setiap pendaftaran dan
                        jualan daripada kongsian ini dikreditkan kepada anda.
                    </p>

                    <KotakLink link={SAYA.ref} onSalin={() => onToast('Link disalin (demo)')} />

                    {/* Pratonton Kad Kongsi berjenama — output yang ahli sebar
                        di WhatsApp/TikTok; kad itu sendiri ialah iklan SESAAT. */}
                    {adaResit && (
                        <div style={{
                            border: '1px solid var(--s-line-strong)', borderRadius: 12,
                            background: 'var(--s-ground)', padding: 18,
                            display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap',
                        }}>
                            <div style={{ flex: 1, minWidth: 180, display: 'flex', flexDirection: 'column', gap: 4 }}>
                                <span style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: '.1em', color: 'var(--s-brand)' }}>SESAAT · KOMUNITI</span>
                                <span style={{ fontSize: 24, fontWeight: 700, color: 'var(--s-ok)', fontVariantNumeric: 'tabular-nums' }}>
                                    +{post.resit.jumlah}
                                </span>
                                <span className="s-dim">Komisen hari ini · {post.oleh.handle}</span>
                                <span className="s-dim" style={{ marginTop: 6 }}>{SAYA.link}</span>
                            </div>
                            <span style={{
                                width: 74, height: 74, borderRadius: 10, flex: 'none',
                                border: '1px dashed var(--s-line-strong)',
                                display: 'grid', placeItems: 'center', color: 'var(--s-ink-3)',
                            }}><QrCode size={34} strokeWidth={1.4} /></span>
                        </div>
                    )}

                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        <Btn variant="ghost" size="sm" icon={<MessageCircle size={13} />} onClick={() => { onToast('Dikongsi ke WhatsApp (demo)'); onTutup(); }}>WhatsApp</Btn>
                        <Btn variant="ghost" size="sm" icon={<Play size={13} />} onClick={() => { onToast('Dikongsi ke TikTok (demo)'); onTutup(); }}>TikTok</Btn>
                        <Btn variant="ghost" size="sm" icon={<Link2 size={13} />} onClick={() => { onToast('Link disalin (demo)'); onTutup(); }}>Salin link</Btn>
                        {adaResit && (
                            <>
                                <span style={{ flex: 1 }} />
                                <Btn size="sm" icon={<Download size={13} />} onClick={() => { onToast('Kad Kongsi dimuat turun (demo)'); onTutup(); }}>
                                    Muat turun kad
                                </Btn>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ════════════════════════════════════════════════════════════
   HALAMAN 1 — FEED
   ════════════════════════════════════════════════════════════ */

const HalamanFeed = ({ tetamu, setTetamu, onToast, onKongsi }) => {
    const [tapis, setTapis] = useState('semua');

    const posts = useMemo(() => {
        const pin = POSTS.filter((p) => p.pin);
        const lain = POSTS.filter((p) => !p.pin && (tapis === 'semua' || p.jenis === tapis));
        return [...pin, ...lain];
    }, [tapis]);

    return (
        <div className="f1-page">
            {/* Banner mod tetamu — lakaran apa yang orang LUAR nampak. */}
            {tetamu && (
                <div style={{
                    display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
                    border: '1px solid var(--s-line-strong)', borderRadius: 12,
                    background: 'var(--s-brand-soft)', padding: '13px 16px', marginBottom: 20,
                }}>
                    <Eye size={16} style={{ color: 'var(--s-brand)', flex: 'none' }} />
                    <span style={{ flex: 1, minWidth: 220, fontSize: 13, color: 'var(--s-ink)', lineHeight: 1.5 }}>
                        <strong>Paparan tetamu.</strong> Inilah yang orang luar nampak bila membuka
                        link ahli — sebahagian kandungan dikunci, dan pintu masuknya percuma.
                    </span>
                    <Btn size="sm" onClick={() => onToast('Demo — borang daftar percuma')}>Sertai Percuma</Btn>
                    <Btn size="sm" variant="quiet" onClick={() => setTetamu(false)}>Tutup mod tetamu</Btn>
                </div>
            )}

            <div className="f1-feedgrid">
                {/* ── Lajur utama ────────────────────────────────── */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 14, minWidth: 0 }}>
                    {/* Composer */}
                    {!tetamu && (
                        <Card>
                            <div style={{ padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 11 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 11 }}>
                                    <Avatar ahli={SAYA} saiz={34} />
                                    <button
                                        type="button"
                                        onClick={() => onToast('Composer — demo')}
                                        style={{
                                            flex: 1, minWidth: 0, textAlign: 'left', cursor: 'text',
                                            height: 38, padding: '0 13px', borderRadius: 8,
                                            border: '1px solid var(--s-line-strong)', background: 'var(--s-ground)',
                                            color: 'var(--s-ink-3)', fontFamily: 'inherit', fontSize: 13.5,
                                            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                        }}
                                    >
                                        Kongsi kejayaan, tip atau soalan anda…
                                    </button>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                                    {[
                                        { l: 'Resit Jualan', I: TrendingUp },
                                        { l: 'Tip', I: Zap },
                                        { l: 'Soalan', I: MessageCircle },
                                        { l: 'Video', I: Play },
                                    ].map(({ l, I }) => (
                                        <button
                                            key={l} type="button" className="s-gchip"
                                            onClick={() => onToast(`Post ${l} — demo`)}
                                        >
                                            <I size={12} /> {l}
                                        </button>
                                    ))}
                                    <span style={{ flex: 1 }} />
                                    <Btn size="sm" onClick={() => onToast('Hantar post — demo')}>Hantar</Btn>
                                </div>
                            </div>
                        </Card>
                    )}

                    <Segmented options={TAPIS_FEED} value={tapis} onChange={setTapis} />

                    {posts.map((p) => (
                        <PostFeed key={p.id} post={p} tetamu={tetamu} onToast={onToast} onKongsi={onKongsi} />
                    ))}

                    <p className="s-dim" style={{ textAlign: 'center', padding: '10px 0 4px' }}>
                        Mockup UI — data contoh, tiada backend.
                    </p>
                </div>

                {/* ── Lajur kanan ────────────────────────────────── */}
                <aside className="f1-aside" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                    {tetamu ? (
                        /* Tetamu nampak SATU benda: pintu masuk. */
                        <Card>
                            <div style={{ padding: 18, display: 'flex', flexDirection: 'column', gap: 10 }}>
                                <span style={{ fontSize: 14.5, fontWeight: 600 }}>Sertai komuniti ejen affiliate</span>
                                <p className="s-dim" style={{ lineHeight: 1.55 }}>
                                    Belajar daripada resit sebenar, ambil formula percuma dan mula
                                    jana video anda sendiri. Pendaftaran percuma.
                                </p>
                                <Btn onClick={() => onToast('Demo — borang daftar percuma')}>Daftar Percuma</Btn>
                            </div>
                        </Card>
                    ) : (
                        <>
                            {/* Kad saya — ringkasan + progres level */}
                            <Card>
                                <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 11 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                        <Avatar ahli={SAYA} saiz={38} />
                                        <span style={{ minWidth: 0, display: 'flex', flexDirection: 'column' }}>
                                            <span style={{ fontSize: 13.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 5 }}>
                                                {SAYA.nama} <BadgeCheck size={13} style={{ color: 'var(--s-brand)' }} />
                                            </span>
                                            <Badge tone="brand" style={{ alignSelf: 'flex-start', marginTop: 3 }}><Crown size={11} /> {SAYA.level}</Badge>
                                        </span>
                                    </div>
                                    <div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11.5, color: 'var(--s-ink-3)', marginBottom: 5 }}>
                                            <span>Menuju: Mentor</span><span>68%</span>
                                        </div>
                                        <div style={{ height: 5, borderRadius: 99, background: 'var(--s-fill)', overflow: 'hidden' }}>
                                            <div style={{ height: '100%', width: '68%', background: 'var(--s-ink)', borderRadius: 99 }} />
                                        </div>
                                    </div>
                                </div>
                            </Card>

                            {/* Top 5 mingguan */}
                            <Card>
                                <div className="s-cardhead">
                                    <div style={{ flex: 1 }}>
                                        <p className="s-cardhead__t">Top Komisen</p>
                                        <p className="s-cardhead__d">Minggu ini</p>
                                    </div>
                                    <Trophy size={15} style={{ color: 'var(--s-ink-3)' }} />
                                </div>
                                <div style={{ padding: '10px 6px 6px' }}>
                                    {CARTA.komisen.slice(0, 5).map((item, i) => (
                                        <div key={item.ahli.handle} style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '7px 10px' }}>
                                            <span className="s-num" style={{ width: 14, textAlign: 'center' }}>{i + 1}</span>
                                            <Avatar ahli={item.ahli} saiz={24} />
                                            <span style={{ flex: 1, minWidth: 0, fontSize: 12.5, color: 'var(--s-ink-2)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {item.ahli.nama}
                                            </span>
                                            <span style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--s-ok)', fontVariantNumeric: 'tabular-nums' }}>{item.nilai}</span>
                                        </div>
                                    ))}
                                </div>
                            </Card>

                            {/* Widget jemputan — enjin viral di depan mata setiap hari */}
                            <Card>
                                <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 10 }}>
                                    <span style={{ fontSize: 13.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 7 }}>
                                        <Gift size={14} style={{ color: 'var(--s-brand)' }} /> Jemput 3, buka kelas percuma
                                    </span>
                                    <div style={{ display: 'flex', gap: 5 }}>
                                        {[1, 2, 3].map((n) => (
                                            <span key={n} style={{
                                                flex: 1, height: 5, borderRadius: 99,
                                                background: n <= 2 ? 'var(--s-ink)' : 'var(--s-fill)',
                                            }} />
                                        ))}
                                    </div>
                                    <span className="s-dim">2 daripada 3 rakan sudah mendaftar.</span>
                                    <Btn size="sm" variant="ghost" onClick={() => onToast('Demo — buka halaman Jemput Rakan')}>Jemput lagi</Btn>
                                </div>
                            </Card>

                            {/* Geng 1K — ritual newbie: follow-memfollow sampai 1,000
                                pengikut untuk buka TikTok affiliate. Sebab paling kuat
                                orang luar daftar akaun percuma. */}
                            <Card>
                                <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 9 }}>
                                    <span style={{ fontSize: 13.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 7 }}>
                                        <Users size={14} style={{ color: 'var(--s-ink-2)' }} /> Geng 1K
                                    </span>
                                    <p className="s-dim" style={{ margin: 0, lineHeight: 1.5 }}>
                                        Belum cukup 1,000 pengikut untuk buka TikTok affiliate?
                                        Sertai skuad follow-memfollow ahli baharu.
                                    </p>
                                    <span className="s-dim" style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                        <Flame size={12} /> 86 ahli sedang aktif
                                    </span>
                                    <Btn size="sm" variant="ghost" onClick={() => onToast('Demo — sertai Geng 1K')}>Sertai skuad</Btn>
                                </div>
                            </Card>

                            {/* Kelas seterusnya */}
                            <Card>
                                <div style={{ padding: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <span style={{
                                        width: 40, height: 40, borderRadius: 9, flex: 'none',
                                        display: 'grid', placeItems: 'center',
                                        background: 'var(--s-fill)', color: 'var(--s-ink-2)',
                                    }}><CalendarDays size={17} /></span>
                                    <span style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
                                        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--s-ink)' }}>{KELAS[0].tajuk}</span>
                                        <span className="s-dim">{KELAS[0].masa} · {KELAS[0].jam}</span>
                                    </span>
                                    <ChevronRight size={15} style={{ color: 'var(--s-ink-3)' }} />
                                </div>
                            </Card>
                        </>
                    )}
                </aside>
            </div>
        </div>
    );
};

/* ════════════════════════════════════════════════════════════
   HALAMAN 2 — MARKETPLACE AHLI
   ════════════════════════════════════════════════════════════ */

const HalamanMarketplace = ({ onToast }) => {
    const [tapis, setTapis] = useState('semua');
    const senarai = PRODUK.filter((p) => tapis === 'semua' || p.jenis === tapis);

    return (
        <div className="f1-page">
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap', marginBottom: 20 }}>
                <div>
                    <h1 className="s-title">Marketplace Ahli</h1>
                    <p className="s-subtitle" style={{ marginTop: 4 }}>
                        Panduan, kelas, membership, custom GPT dan formula — dibina oleh ahli, untuk ahli.
                    </p>
                </div>
                <Field icon={<Search size={14} />} placeholder="Cari produk atau penjual…" style={{ minWidth: 240 }} />
            </div>

            {/* Program reseller — flywheel Whop: semua ahli boleh jadi pengedar */}
            <Card style={{ marginBottom: 18 }}>
                <div style={{ padding: '15px 18px', display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
                    <span style={{
                        width: 38, height: 38, borderRadius: 9, flex: 'none',
                        display: 'grid', placeItems: 'center',
                        background: 'var(--s-brand-soft)', color: 'var(--s-brand)',
                    }}><Share2 size={17} /></span>
                    <span style={{ flex: 1, minWidth: 220 }}>
                        <span style={{ fontSize: 13.5, fontWeight: 600, display: 'block' }}>Program Reseller</span>
                        <span className="s-dim">Promosi produk ahli lain dengan link anda — komisen sehingga 30% setiap jualan.</span>
                    </span>
                    <Btn size="sm" variant="ghost" onClick={() => onToast('Demo — senarai produk boleh promosi')}>Lihat cara</Btn>
                </div>
            </Card>

            <div style={{ marginBottom: 16, overflowX: 'auto' }}>
                <Segmented options={TAPIS_PRODUK} value={tapis} onChange={setTapis} />
            </div>

            <div className="s-pgrid">
                {senarai.map((p) => (
                    <KadProduk key={p.id} p={p} onBuka={() => onToast('Demo — halaman produk belum dibina')} onToast={onToast} />
                ))}

                {/* CTA buka kedai sendiri */}
                <button
                    type="button"
                    onClick={() => onToast('Demo — buka kedai di Profil Saya')}
                    style={{
                        border: '1px dashed var(--s-line-strong)', borderRadius: 'var(--s-r-lg)',
                        background: 'none', cursor: 'pointer', minHeight: 220,
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        gap: 10, color: 'var(--s-ink-3)', fontFamily: 'inherit', padding: 20,
                    }}
                >
                    <span style={{
                        width: 38, height: 38, borderRadius: 10, display: 'grid', placeItems: 'center',
                        background: 'var(--s-fill-hover)', color: 'var(--s-ink-2)',
                    }}><Plus size={18} /></span>
                    <span style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--s-ink-2)' }}>Jual produk anda</span>
                    <span style={{ fontSize: 12, lineHeight: 1.5, textAlign: 'center' }}>
                        Ebook, kelas atau formula — buka kedai percuma di profil anda.
                    </span>
                </button>
            </div>
        </div>
    );
};

/* ════════════════════════════════════════════════════════════
   HALAMAN 3 — PROFIL & KEDAI SAYA (landing page awam)
   ════════════════════════════════════════════════════════════ */

const HalamanProfil = ({ tetamu, setTetamu, onToast, onKongsi }) => {
    const [tab, setTab] = useState('koleksi');

    return (
        <div className="f1-page" style={{ maxWidth: 920 }}>
            {/* Nota konsep: profil = landing page yang ahli letak di bio TikTok */}
            {!tetamu && (
                <div style={{
                    display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
                    border: '1px solid var(--s-line)', borderRadius: 10,
                    padding: '11px 14px', marginBottom: 18,
                }}>
                    <Eye size={14} style={{ color: 'var(--s-ink-3)', flex: 'none' }} />
                    <span className="s-dim" style={{ flex: 1, minWidth: 200 }}>
                        Halaman ini terbuka kepada UMUM di <strong style={{ color: 'var(--s-ink-2)' }}>{SAYA.link}</strong> —
                        sesuai diletak di bio TikTok anda.
                    </span>
                    <Btn size="sm" variant="quiet" icon={<Eye size={13} />} onClick={() => setTetamu(true)}>
                        Lihat sebagai tetamu
                    </Btn>
                </div>
            )}

            {/* Kepala profil */}
            <Card style={{ marginBottom: 16 }}>
                <div style={{ height: 84, background: 'var(--s-brand-soft)', borderBottom: '1px solid var(--s-line)' }} />
                <div style={{ padding: '0 22px 20px' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 16, flexWrap: 'wrap', marginTop: -26 }}>
                        <span style={{
                            width: 76, height: 76, borderRadius: 99, flex: 'none',
                            display: 'grid', placeItems: 'center',
                            background: 'var(--s-brand-soft)', color: 'var(--s-brand)',
                            border: '3px solid var(--s-card)', fontSize: 24, fontWeight: 600,
                        }}>{inisial(SAYA.nama)}</span>
                        <div style={{ flex: 1, minWidth: 200, paddingBottom: 2 }}>
                            <span style={{ display: 'flex', alignItems: 'center', gap: 7, flexWrap: 'wrap' }}>
                                <span style={{ fontSize: 18, fontWeight: 600 }}>{SAYA.nama}</span>
                                <BadgeCheck size={16} style={{ color: 'var(--s-brand)' }} />
                                <Badge tone="brand"><Crown size={11} /> {SAYA.level}</Badge>
                            </span>
                            <span className="s-dim">{SAYA.handle} · {SAYA.link}</span>
                        </div>
                        <div style={{ display: 'flex', gap: 8, paddingBottom: 2, flexWrap: 'wrap' }}>
                            {tetamu ? (
                                <>
                                    <Btn size="sm" onClick={() => onToast('Demo — follow selepas daftar percuma')}>Follow</Btn>
                                    <Btn size="sm" variant="ghost" onClick={() => onToast('Demo — borang daftar percuma')}>Sertai SESAAT</Btn>
                                </>
                            ) : (
                                <>
                                    <Btn size="sm" variant="ghost" icon={<Copy size={13} />} onClick={() => onToast('Link profil disalin (demo)')}>Salin link</Btn>
                                    <Btn size="sm" icon={<Share2 size={13} />} onClick={() => onKongsi({ oleh: SAYA, resit: null })}>Kongsi profil</Btn>
                                </>
                            )}
                        </div>
                    </div>

                    <p style={{ margin: '14px 0 0', fontSize: 13.5, lineHeight: 1.6, color: 'var(--s-ink-2)', maxWidth: 560 }}>
                        {SAYA.bio}
                    </p>

                    <div style={{ display: 'flex', gap: 22, marginTop: 14, flexWrap: 'wrap', fontVariantNumeric: 'tabular-nums' }}>
                        {[
                            [SAYA.pengikut.toLocaleString(), 'Pengikut'],
                            [SAYA.jualan.toLocaleString(), 'Jualan produk'],
                            [SAYA.pelajar.toLocaleString(), 'Pelajar'],
                        ].map(([v, l]) => (
                            <span key={l} style={{ display: 'flex', flexDirection: 'column' }}>
                                <span style={{ fontSize: 16, fontWeight: 700, color: 'var(--s-ink)' }}>{v}</span>
                                <span className="s-dim">{l}</span>
                            </span>
                        ))}
                    </div>
                </div>
            </Card>

            <div style={{ marginBottom: 16 }}>
                <Segmented
                    value={tab} onChange={setTab}
                    options={[
                        { value: 'koleksi', label: 'Koleksi Saya' },
                        { value: 'testimoni', label: 'Testimoni' },
                        { value: 'tentang', label: 'Tentang' },
                    ]}
                />
            </div>

            {tab === 'koleksi' && (
                <div className="s-pgrid">
                    {PRODUK.filter((p) => p.oleh === SAYA).map((p) => (
                        <KadProduk key={p.id} p={p} onBuka={() => onToast('Demo — halaman produk belum dibina')} onToast={onToast} />
                    ))}
                    {!tetamu && (
                        <button
                            type="button"
                            onClick={() => onToast('Demo — borang tambah produk')}
                            style={{
                                border: '1px dashed var(--s-line-strong)', borderRadius: 'var(--s-r-lg)',
                                background: 'none', cursor: 'pointer', minHeight: 220,
                                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                                gap: 10, color: 'var(--s-ink-3)', fontFamily: 'inherit', padding: 20,
                            }}
                        >
                            <span style={{
                                width: 38, height: 38, borderRadius: 10, display: 'grid', placeItems: 'center',
                                background: 'var(--s-fill-hover)', color: 'var(--s-ink-2)',
                            }}><Plus size={18} /></span>
                            <span style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--s-ink-2)' }}>Tambah produk</span>
                            <span style={{ fontSize: 12, lineHeight: 1.5, textAlign: 'center' }}>
                                Ebook · Kelas · Membership · Custom GPT · Formula · Link aff
                            </span>
                        </button>
                    )}
                </div>
            )}

            {tab === 'testimoni' && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {TESTIMONI.map((t, i) => (
                        <Card key={i}>
                            <div style={{ padding: '14px 16px', display: 'flex', gap: 12 }}>
                                <Avatar ahli={t.oleh} saiz={32} />
                                <div style={{ minWidth: 0 }}>
                                    <span style={{ fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
                                        {t.oleh.nama}
                                        <span style={{ display: 'inline-flex', gap: 1, color: 'var(--s-warn)' }}>
                                            {[1, 2, 3, 4, 5].map((n) => <Star key={n} size={11} fill="currentColor" />)}
                                        </span>
                                    </span>
                                    <p style={{ margin: '5px 0 0', fontSize: 13, lineHeight: 1.6, color: 'var(--s-ink-2)' }}>{t.teks}</p>
                                </div>
                            </div>
                        </Card>
                    ))}
                </div>
            )}

            {tab === 'tentang' && (
                <Card>
                    <div style={{ padding: '16px 18px', display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <p style={{ margin: 0, fontSize: 13.5, lineHeight: 1.65, color: 'var(--s-ink-2)' }}>
                            {SAYA.bio}
                        </p>
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                            <Badge tone="neutral">Ahli sejak Mac 2024</Badge>
                            <Badge tone="neutral">TikTok Shop</Badge>
                            <Badge tone="neutral">Shopee Affiliate</Badge>
                        </div>
                    </div>
                </Card>
            )}
        </div>
    );
};

/* ════════════════════════════════════════════════════════════
   HALAMAN 4 — CARTA JUARA
   ════════════════════════════════════════════════════════════ */

const HalamanCarta = ({ onToast }) => {
    const [tempoh, setTempoh] = useState('minggu');

    return (
        <div className="f1-page" style={{ maxWidth: 1180 }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap', marginBottom: 20 }}>
                <div>
                    <h1 className="s-title">Carta Juara</h1>
                    <p className="s-subtitle" style={{ marginTop: 4 }}>
                        Kedudukan dikira secara automatik daripada resit, jemputan dan kandungan anda.
                    </p>
                </div>
                <Segmented
                    value={tempoh} onChange={setTempoh}
                    options={[
                        { value: 'minggu', label: 'Minggu ini' },
                        { value: 'bulan', label: 'Bulan ini' },
                        { value: 'semua', label: 'Sepanjang masa' },
                    ]}
                />
            </div>

            {/* Hadiah minggu — sebab orang balik setiap Isnin */}
            <Card style={{ marginBottom: 18 }}>
                <div style={{ padding: '13px 16px', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                    <Trophy size={16} style={{ color: 'var(--s-warn)', flex: 'none' }} />
                    <span style={{ flex: 1, minWidth: 200, fontSize: 13, color: 'var(--s-ink-2)' }}>
                        Hadiah minggu ini: <strong style={{ color: 'var(--s-ink)' }}>RM500 tunai</strong> untuk
                        Top Komisen · <strong style={{ color: 'var(--s-ink)' }}>badge Juara</strong> untuk semua Top 3.
                    </span>
                    <Btn size="sm" variant="quiet" onClick={() => onToast('Demo — syarat penuh carta')}>Syarat</Btn>
                </div>
            </Card>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 16, alignItems: 'start' }}>
                {[
                    { kunci: 'komisen', tajuk: 'Top Komisen', nota: 'Resit disahkan melalui post Feed', Ikon: TrendingUp },
                    { kunci: 'jemputan', tajuk: 'Top Jemputan', nota: 'Ahli baharu yang mendaftar & aktif', Ikon: Gift },
                    { kunci: 'kreator', tajuk: 'Top Kreator', nota: 'Reaksi pada post & formula dikongsi', Ikon: Flame },
                ].map(({ kunci, tajuk, nota, Ikon }) => (
                    <div key={kunci} className="s-list">
                        <div style={{ padding: '13px 15px', borderBottom: '1px solid var(--s-line)', display: 'flex', alignItems: 'center', gap: 9 }}>
                            <Ikon size={15} style={{ color: 'var(--s-ink-3)' }} />
                            <span style={{ fontSize: 13.5, fontWeight: 600, flex: 1 }}>{tajuk}</span>
                            <span className="s-dim">{nota}</span>
                        </div>
                        {CARTA[kunci].map((item, i) => (
                            <BarisCarta key={item.ahli.handle} kedudukan={i + 1} item={item} />
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

/* ════════════════════════════════════════════════════════════
   HALAMAN 5 — CABARAN
   ════════════════════════════════════════════════════════════ */

const HalamanCabaran = ({ onToast }) => (
    <div className="f1-page" style={{ maxWidth: 860 }}>
        <div style={{ marginBottom: 20 }}>
            <h1 className="s-title">Cabaran</h1>
            <p className="s-subtitle" style={{ marginTop: 4 }}>
                Setiap cabaran mensyaratkan kandungan di TikTok dengan tag komuniti —
                setiap penyertaan ialah hebahan percuma.
            </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {CABARAN.map((c) => (
                <Card key={c.id}>
                    <div style={{ padding: '16px 18px', display: 'flex', flexDirection: 'column', gap: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                            <span style={{
                                width: 36, height: 36, borderRadius: 9, flex: 'none',
                                display: 'grid', placeItems: 'center',
                                background: c.status === 'aktif' ? 'var(--s-brand-soft)' : 'var(--s-fill)',
                                color: c.status === 'aktif' ? 'var(--s-brand)' : 'var(--s-ink-3)',
                            }}><Target size={17} /></span>
                            <span style={{ flex: 1, minWidth: 180 }}>
                                <span style={{ fontSize: 14.5, fontWeight: 600, display: 'block' }}>{c.tajuk}</span>
                                <span className="s-dim">
                                    {c.status === 'aktif' && `Hari ${c.hari} daripada ${c.jumlahHari} · ${c.peserta} peserta`}
                                    {c.status === 'akan' && c.mula}
                                    {c.status === 'tamat' && `Tamat · ${c.peserta} peserta`}
                                </span>
                            </span>
                            {c.status === 'aktif' && <Badge tone="ok">Sedang berjalan</Badge>}
                            {c.status === 'akan' && <Badge tone="neutral">Akan datang</Badge>}
                            {c.status === 'tamat' && <Badge tone="neutral">Tamat</Badge>}
                        </div>

                        <p style={{ margin: 0, fontSize: 13.5, lineHeight: 1.6, color: 'var(--s-ink-2)' }}>{c.keterangan}</p>

                        {c.status === 'aktif' && (
                            <>
                                <div style={{ height: 6, borderRadius: 99, background: 'var(--s-fill)', overflow: 'hidden' }}>
                                    <div style={{ height: '100%', width: `${Math.round((c.hari / c.jumlahHari) * 100)}%`, background: 'var(--s-ink)', borderRadius: 99 }} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                    {c.syarat.map((s, i) => (
                                        <span key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--s-ink-2)' }}>
                                            <Check size={13} style={{ color: 'var(--s-ink-3)', flex: 'none' }} /> {s}
                                        </span>
                                    ))}
                                </div>
                            </>
                        )}

                        {c.pemenang && (
                            <span style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--s-ink-2)' }}>
                                <Crown size={14} style={{ color: 'var(--s-warn)', flex: 'none' }} />
                                Pemenang: <strong style={{ color: 'var(--s-ink)' }}>{c.pemenang.nama}</strong> ({c.pemenang.handle})
                            </span>
                        )}

                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                            <Badge tone="warn"><Trophy size={11} /> {c.hadiah}</Badge>
                            <span style={{ flex: 1 }} />
                            {c.status === 'aktif' && <Btn size="sm" onClick={() => onToast('Demo — anda menyertai cabaran')}>Sertai</Btn>}
                            {c.status === 'akan' && <Btn size="sm" variant="ghost" onClick={() => onToast('Demo — peringatan ditetapkan')}>Ingatkan saya</Btn>}
                        </div>
                    </div>
                </Card>
            ))}
        </div>
    </div>
);

/* ════════════════════════════════════════════════════════════
   HALAMAN 6 — KELAS LIVE
   ════════════════════════════════════════════════════════════ */

const HalamanKelas = ({ onToast }) => (
    <div className="f1-page" style={{ maxWidth: 860 }}>
        <div style={{ marginBottom: 20 }}>
            <h1 className="s-title">Kelas Live</h1>
            <p className="s-subtitle" style={{ marginTop: 4 }}>
                Sesi live oleh mentor komuniti — percuma untuk ahli, atau berbayar terus kepada hos.
            </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 26 }}>
            {KELAS.map((k) => (
                <Card key={k.id}>
                    <div style={{ padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
                        <span style={{
                            width: 48, height: 48, borderRadius: 10, flex: 'none',
                            border: '1px solid var(--s-line-strong)',
                            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        }}>
                            <span style={{ fontSize: 16, fontWeight: 700, lineHeight: 1, fontVariantNumeric: 'tabular-nums' }}>{k.tarikh}</span>
                            <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: '.08em', color: 'var(--s-ink-3)' }}>{k.bulan}</span>
                        </span>
                        <span style={{ flex: 1, minWidth: 200, display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <span style={{ fontSize: 14, fontWeight: 600 }}>{k.tajuk}</span>
                            <span className="s-dim" style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                                <Avatar ahli={k.host} saiz={17} /> {k.host.nama}
                                <span>· <Clock size={11} style={{ display: 'inline', verticalAlign: '-1px' }} /> {k.jam}</span>
                                <span>· {k.rsvp} RSVP</span>
                            </span>
                        </span>
                        <Badge tone={k.harga === 'Percuma' ? 'ok' : 'neutral'}>{k.harga}</Badge>
                        <Btn size="sm" onClick={() => onToast('Demo — RSVP direkod')}>RSVP</Btn>
                    </div>
                </Card>
            ))}
        </div>

        <p style={{ fontSize: 13, fontWeight: 600, color: 'var(--s-ink-2)', margin: '0 0 10px' }}>Rakaman terdahulu</p>
        <div className="s-list">
            {RAKAMAN.map((r) => (
                <div key={r.id} className="s-list__row">
                    <span style={{
                        width: 30, height: 30, borderRadius: 8, flex: 'none',
                        display: 'grid', placeItems: 'center',
                        background: 'var(--s-fill)', color: 'var(--s-ink-3)',
                    }}>{r.kunci ? <Lock size={13} /> : <Play size={13} />}</span>
                    <span style={{ flex: 1, minWidth: 0, fontSize: 13.5, color: 'var(--s-ink)' }}>{r.tajuk}</span>
                    <span className="s-num">{r.tempoh}</span>
                    {r.kunci
                        ? <Badge tone="neutral"><Lock size={10} /> Jemput 1 rakan untuk buka</Badge>
                        : <Badge tone="ok">Percuma</Badge>}
                </div>
            ))}
        </div>
    </div>
);

/* ════════════════════════════════════════════════════════════
   HALAMAN 7 — JEMPUT RAKAN (enjin viral)
   ════════════════════════════════════════════════════════════ */

const HalamanJemput = ({ onToast }) => (
    <div className="f1-page" style={{ maxWidth: 860 }}>
        <div style={{ marginBottom: 20 }}>
            <h1 className="s-title">Jemput Rakan</h1>
            <p className="s-subtitle" style={{ marginTop: 4 }}>
                Setiap rakan yang mendaftar melalui link anda membuka ganjaran — dan
                dikira ke Carta Top Jemputan.
            </p>
        </div>

        {/* Statistik ringkas */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 12, marginBottom: 18 }}>
            {[
                ['23', 'Jemputan anda'],
                ['17', 'Sudah mendaftar'],
                ['9', 'Aktif minggu ini'],
                ['RM120', 'Nilai ganjaran dibuka'],
            ].map(([v, l]) => (
                <div key={l} className="s-stat">
                    <span className="s-stat__label">{l}</span>
                    <span className="s-stat__value">{v}</span>
                </div>
            ))}
        </div>

        {/* Link + saluran */}
        <Card style={{ marginBottom: 18 }}>
            <div style={{ padding: '16px 18px', display: 'flex', flexDirection: 'column', gap: 12 }}>
                <span style={{ fontSize: 13.5, fontWeight: 600 }}>Link jemputan anda</span>
                <KotakLink link={SAYA.ref} onSalin={() => onToast('Link disalin (demo)')} />
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <Btn variant="ghost" size="sm" icon={<MessageCircle size={13} />} onClick={() => onToast('Demo — kongsi ke WhatsApp')}>WhatsApp</Btn>
                    <Btn variant="ghost" size="sm" icon={<Play size={13} />} onClick={() => onToast('Demo — kongsi ke TikTok')}>TikTok</Btn>
                    <Btn variant="ghost" size="sm" icon={<QrCode size={13} />} onClick={() => onToast('Demo — jana QR')}>Kod QR</Btn>
                </div>
            </div>
        </Card>

        {/* Trek ganjaran */}
        <Card style={{ marginBottom: 18 }}>
            <div className="s-cardhead">
                <div style={{ flex: 1 }}>
                    <p className="s-cardhead__t">Trek ganjaran</p>
                    <p className="s-cardhead__d">Ganjaran dibuka mengikut jumlah rakan yang mendaftar.</p>
                </div>
                <Gift size={15} style={{ color: 'var(--s-ink-3)' }} />
            </div>
            <div style={{ padding: '14px 18px 18px' }}>
                {GANJARAN.map((g, i) => (
                    <div key={g.sasaran} style={{ display: 'flex', gap: 13 }}>
                        <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 'none' }}>
                            <span style={{
                                width: 26, height: 26, borderRadius: 99,
                                display: 'grid', placeItems: 'center', fontSize: 11.5, fontWeight: 700,
                                background: g.capai ? 'var(--s-select)' : 'var(--s-fill)',
                                color: g.capai ? 'var(--s-select-ink)' : 'var(--s-ink-3)',
                                border: g.capai ? 'none' : '1px solid var(--s-line-strong)',
                                fontVariantNumeric: 'tabular-nums',
                            }}>{g.capai ? <Check size={13} /> : g.sasaran}</span>
                            {i < GANJARAN.length - 1 && (
                                <span style={{ width: 1, flex: 1, minHeight: 18, background: 'var(--s-line-strong)' }} />
                            )}
                        </span>
                        <span style={{ paddingBottom: i < GANJARAN.length - 1 ? 16 : 0, display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <span style={{ fontSize: 13.5, fontWeight: 600, color: g.capai ? 'var(--s-ink)' : 'var(--s-ink-2)' }}>
                                {g.sasaran} rakan — {g.label}
                            </span>
                            <span className="s-dim">{g.capai ? 'Dibuka' : `${g.sasaran - 17 > 0 ? g.sasaran - 17 : 0} lagi untuk buka`}</span>
                        </span>
                    </div>
                ))}
            </div>
        </Card>

        {/* Kad Kongsi sedia guna */}
        <Card>
            <div className="s-cardhead">
                <div style={{ flex: 1 }}>
                    <p className="s-cardhead__t">Kad Kongsi sedia guna</p>
                    <p className="s-cardhead__d">
                        Poster berjenama dengan link anda tertanam — muat turun dan sebar di
                        WhatsApp status atau TikTok story.
                    </p>
                </div>
                <QrCode size={15} style={{ color: 'var(--s-ink-3)' }} />
            </div>
            <div style={{ padding: '14px 18px 18px', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 12 }}>
                {[
                    { t: 'Resit Komisen', d: 'Auto dari post resit anda', I: TrendingUp },
                    { t: 'Rumusan Bulanan', d: 'Video dijana, streak & rank anda', I: Crown },
                    { t: 'Jemputan Komuniti', d: 'Poster ajak sertai', I: Users },
                ].map(({ t, d, I }) => (
                    <button
                        key={t} type="button"
                        onClick={() => onToast('Demo — pratonton & muat turun kad')}
                        style={{
                            border: '1px solid var(--s-line-strong)', borderRadius: 10,
                            background: 'var(--s-ground)', cursor: 'pointer', fontFamily: 'inherit',
                            aspectRatio: '9 / 14', padding: 12,
                            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8,
                        }}
                    >
                        <I size={20} style={{ color: 'var(--s-brand)' }} />
                        <span style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--s-ink)', textAlign: 'center' }}>{t}</span>
                        <span style={{ fontSize: 11, color: 'var(--s-ink-3)', textAlign: 'center', lineHeight: 1.4 }}>{d}</span>
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, fontWeight: 600, color: 'var(--s-ink-2)' }}>
                            <Download size={11} /> Muat turun
                        </span>
                    </button>
                ))}
            </div>
        </Card>
    </div>
);

/* ════════════════════════════════════════════════════════════
   RANGKA UTAMA — rel komuniti + kandungan
   ════════════════════════════════════════════════════════════ */

const MENU = [
    {
        label: 'KOMUNITI',
        item: [
            { id: 'feed', label: 'Feed', Ikon: Newspaper },
            { id: 'carta', label: 'Carta Juara', Ikon: Trophy },
            { id: 'cabaran', label: 'Cabaran', Ikon: Target },
            { id: 'kelas', label: 'Kelas Live', Ikon: GraduationCap },
        ],
    },
    {
        label: 'MONETIZE',
        item: [
            { id: 'marketplace', label: 'Marketplace Ahli', Ikon: Store },
            { id: 'profil', label: 'Profil & Kedai Saya', Ikon: CircleUser },
        ],
    },
    {
        label: 'GROWTH',
        item: [
            { id: 'jemput', label: 'Jemput Rakan', Ikon: Gift, badge: 'Ganjaran' },
        ],
    },
];

export default function Feed1View() {
    const navigate = useNavigate();
    const [halaman, setHalaman] = useState('feed');
    const [tetamu, setTetamu] = useState(false);
    const [toast, setToast] = useState(null);
    const [kongsiUntuk, setKongsiUntuk] = useState(null);

    const tunjukToast = (msg) => {
        setToast(msg);
        window.clearTimeout(tunjukToast._t);
        tunjukToast._t = window.setTimeout(() => setToast(null), 1900);
    };

    const props = { tetamu, setTetamu, onToast: tunjukToast, onKongsi: setKongsiUntuk };

    return (
        <div
            className="s-root"
            style={{
                position: 'fixed', inset: 0, zIndex: 50,
                display: 'grid', gridTemplateColumns: 'auto 1fr',
                background: 'var(--s-ground)',
            }}
        >
            {/* Media query tidak boleh duduk dalam inline style — blok kecil ini
                menguruskan susun atur feed + rel pada skrin sempit. */}
            <style>{`
                .f1-page { max-width: 1080px; margin: 0 auto; padding: 26px 28px 64px; }
                .f1-feedgrid { display: grid; grid-template-columns: minmax(0, 1fr) 308px; gap: 22px; align-items: start; }
                @media (max-width: 1200px) {
                    .f1-feedgrid { grid-template-columns: minmax(0, 1fr); }
                    .f1-aside { display: none !important; }
                }
                @media (max-width: 900px) {
                    .f1-rail { display: none !important; }
                }
                .f1-page::-webkit-scrollbar { width: 8px; }
            `}</style>

            {/* ── Rel komuniti ─────────────────────────────────── */}
            <aside
                className="f1-rail"
                style={{
                    width: 264, height: '100%', flex: 'none',
                    borderRight: '1px solid var(--s-line)',
                    padding: '16px 12px 14px',
                    display: 'flex', flexDirection: 'column', gap: 18,
                    overflowY: 'auto', minWidth: 0,
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '0 4px' }}>
                    <span style={{ fontSize: 18, fontWeight: 600, letterSpacing: '-.01em' }}>Sesaat</span>
                    <span style={{
                        fontSize: 8, fontWeight: 700, letterSpacing: '.06em',
                        padding: '2px 5px', borderRadius: 4,
                        background: 'var(--s-brand-soft)', color: 'var(--s-brand)',
                    }}>KOMUNITI</span>
                    <span style={{ flex: 1 }} />
                    <Avatar ahli={SAYA} saiz={22} />
                </div>

                {MENU.map((g) => (
                    <div key={g.label} style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <LabelKumpulan>{g.label}</LabelKumpulan>
                        {g.item.map(({ id, label, Ikon, badge }) => (
                            <NavRow
                                key={id}
                                active={halaman === id}
                                icon={<Ikon size={16} strokeWidth={1.9} />}
                                onClick={() => setHalaman(id)}
                            >
                                <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                    <span style={{ flex: 1 }}>{label}</span>
                                    {badge && <Badge tone="brand">{badge}</Badge>}
                                </span>
                            </NavRow>
                        ))}
                    </div>
                ))}

                <div style={{ marginTop: 'auto', display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {/* Suis mod tetamu — alat demo funnel: apa orang luar nampak. */}
                    <NavRow
                        active={tetamu}
                        icon={<Eye size={16} strokeWidth={1.9} />}
                        onClick={() => setTetamu(!tetamu)}
                    >
                        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <span style={{ flex: 1 }}>Mod tetamu</span>
                            {tetamu && <Badge tone="warn">ON</Badge>}
                        </span>
                    </NavRow>
                    <NavRow
                        icon={<ArrowLeftFromLine size={16} strokeWidth={1.9} />}
                        onClick={() => navigate('/dashboard')}
                    >
                        Kembali ke App
                    </NavRow>
                    <p style={{ fontSize: 11, color: 'var(--s-ink-3)', margin: '10px 0 0', padding: '0 8px', lineHeight: 1.5 }}>
                        Mockup UI · /feed1<br />Data contoh, tiada backend.
                    </p>
                </div>
            </aside>

            {/* ── Kandungan ────────────────────────────────────── */}
            <ContentPanel>
                {halaman === 'feed' && <HalamanFeed {...props} />}
                {halaman === 'marketplace' && <HalamanMarketplace onToast={tunjukToast} />}
                {halaman === 'profil' && <HalamanProfil {...props} />}
                {halaman === 'carta' && <HalamanCarta onToast={tunjukToast} />}
                {halaman === 'cabaran' && <HalamanCabaran onToast={tunjukToast} />}
                {halaman === 'kelas' && <HalamanKelas onToast={tunjukToast} />}
                {halaman === 'jemput' && <HalamanJemput onToast={tunjukToast} />}
            </ContentPanel>

            {/* Modal kongsi */}
            <ModalKongsi post={kongsiUntuk} onTutup={() => setKongsiUntuk(null)} onToast={tunjukToast} />

            {/* Toast */}
            {toast && (
                <div style={{
                    position: 'fixed', bottom: 26, left: '50%', transform: 'translateX(-50%)',
                    zIndex: 300, display: 'flex', alignItems: 'center', gap: 8,
                    padding: '10px 16px', borderRadius: 99,
                    background: 'var(--s-card)', border: '1px solid var(--s-line-strong)',
                    color: 'var(--s-ink)', fontSize: 13, fontWeight: 500,
                    boxShadow: '0 18px 44px -16px rgba(0,0,0,.75)',
                }}>
                    <Check size={14} style={{ color: 'var(--s-ok)' }} /> {toast}
                </div>
            )}
        </div>
    );
}
